// "Genel Yönetici" = yalnızca super_admin. Tüm komitelere yetkili komite yöneticileri
// genel yönetici sayılmaz; onlara diğer komite yöneticileri gibi davranılır.
export const isGeneralManager = (u) => u?.role === "super_admin";

// Radar: sistem sahibi, şube yöneticisi veya kullanıcı bazlı Radar yetkisi olanlar.
export const canRadar = (u) =>
  u?.role === "super_admin" || u?.role === "branch_manager" || !!u?.radar_access;

// Radar dışa aktarma (Excel/PDF) yalnız genel yönetici ve şube yöneticisinde.
export const canRadarExport = (u) =>
  u?.role === "super_admin" || u?.role === "branch_manager";
